/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_earn_yoga_teaching_certificates: Phrase =locale => {
  const en = `Earn yoga teaching certificates.`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Obtén certificados de enseñanza.`,
  };
  return phrases[locale] || en;
};
            